/******** product page specific ***start***/

function getCartEditStorageData(){
  try {
    var raw = window.localStorage.getItem('customers_canvas');
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
}

function checkForErrors($ele){
  var messages = errors.size.concat(errors.qty);
  messages = $.unique(messages);
  var allowAddToCart = true;
  if(messages.length){
    $('#errormessage').html(messages.join('<br>')).show();
    $('#custom-quantity-table td.custom-quantity-table--unit-ptice').addClass("hide-value");
    $('#custom-quantity-table td.quantity-table--total').addClass("hide-value");
    $('#productPrice').addClass("hide-value");
    $('.unitPrice').addClass("hide-value");
    $('button.sticky-add-to-cart-btn > span.sticky-atc-price').hide();
    $('div.description-section.productBottomprice > div.row.selector-wrapper').hide();
    allowAddToCart = false;
  }else{
    $('#errormessage').html('').removeAttr("style").hide();
    $('#custom-quantity-table td.custom-quantity-table--unit-ptice').removeClass("hide-value");
    $('#custom-quantity-table td.quantity-table--total').removeClass("hide-value");
    $('#productPrice').removeClass("hide-value");
    $('.unitPrice').removeClass("hide-value");
    $('button.sticky-add-to-cart-btn > span.sticky-atc-price').show();
    $('div.description-section.productBottomprice > div.row.selector-wrapper').show();
  }
  if(allowAddToCart){
    var ccReady = (typeof window._ccTemplateReady === 'undefined') ? true : window._ccTemplateReady;
    var guestCanStart = !!window._ccGuestDesignNowPending;
    if (ccReady || guestCanStart) {
    $('#editor_upload_button').removeClass('disabled').prop('disabled', false);
    $('#editor_upload_button_test').removeClass('disabled').prop('disabled', false);
  }
    $('.price').show();
    $ele.removeClass('disabled').prop('disabled', false);
  }else{
    $('#editor_upload_button').addClass('disabled').prop('disabled', true);
    $('#editor_upload_button_test').addClass('disabled').prop('disabled', true);
    $ele.addClass('disabled').prop('disabled', true);
    return;
  }
}

function getQty(currentOnly, type){ // calculates qty entered in field in addition to the related qty in cart (if any)
  var qty = parseInt($('#quantity').val());
  currentOnly = typeof(currentOnly) == "boolean"?currentOnly:false;
  type = typeof type != "undefined" ? type : 'product';
  if(!currentOnly){
    var cartEditData = getCartEditStorageData();
    var selectedVariant = $selVarEle.val();
    let lineItems = [];
    if(type == 'product'){
      lineItems = cart.filter(item => item.id == selectedVariant);
    }else if(type == 'overlamination'){
      lineItems = cart.filter(item => item.id == selectedVariant && isset(item.properties) && isset(item.properties['Overlamination']) && item.properties['Overlamination'] == "Yes");
    }else if(type == 'foil_stamping'){
      lineItems = cart.filter(item => item.id == selectedVariant && isset(item.properties) && isset(item.properties['Foil Stamping']) && item.properties['Foil Stamping'] == "Yes");
    }else if(type == 'numbering'){
      lineItems = cart.filter(item => item.id == selectedVariant && isset(item.properties) && isset(item.properties['Numbering']) && item.properties['Numbering'] == "Yes");
    }else if(type == 'matte'){
      lineItems = cart.filter(item => item.id == selectedVariant && isset(item.properties) && isset(item.properties['Matte Varnish']) && item.properties['Matte Varnish'] == "Yes");
    }
    if (cartEditData && cartEditData.cart_item_key) {
      lineItems = lineItems.filter(item => item.key !== cartEditData.cart_item_key);
    }
    lineItems.map(item => qty += item.quantity);
  }
  return qty;
}

function validateQty(priceObject){
  var currentQty = getQty(true);
  errors.qty = [];
  checkForErrors($('#addToCart'));
  if(priceObject){
    var minCustomQty = document.getElementById('custom-quantity-input')?.getAttribute('data-minQty');
    var minQty =  minCustomQty ? parseInt(minCustomQty) : Object.keys(priceObject.prices)[0];
    if(currentQty < minQty){ // checking if cart qty + current qty is less than min price object qty
      errors.qty.push(`Minimum ${minCustomQty ? 'custom' : 'order'} quantity for this product is ${minQty}. Add ${(minQty-currentQty)} more.`);
      checkForErrors($('#addToCart'));
    }
    if(!currentQty){ // checking if current qty is NaN
      errors.qty.push('Minimum order quantity for this product is '+minQty+'. Add '+(minQty)+' more.');
      checkForErrors($('#addToCart'));
    }
  }
}

function setPricing(){ // sets the price in html and cart item property
  var totalQty = getQty();
  var currentQty = getQty(true);
  var overlaminationQty = getQty(false,'overlamination');
  var foilStampingQty = getQty(false,'foil_stamping');
  var numberingQty = getQty(false,'numbering');
  var matteQty = getQty(false,'matte');
  var selectedVariantId = $selVarEle.val();
  var selectedVariantSku = $selVarEle.find('[value='+selectedVariantId+']').first().data('sku');
  var selectedVariantBarcode = getBarcodeFromSku(selectedVariantSku);
  var priceObject = getPricingObject(selectedVariantBarcode, currentProductPriceJson);
  if(priceObject){
    var minLotQty = parseInt(Object.keys(priceObject["prices"])[0]);
  }
  var basePrice = $selVarEle.find('[value='+selectedVariantId+']').first().data('price')/100;
  var discountedPrice = toFixed(getDiscountedPrice(totalQty, priceObject, 'prices', lot_pricing), 2);
  console.log(discountedPrice, toFixed(discountedPrice, 2))
  let initialPrice = null;
  if (priceObject) {
    initialPrice = toFixed(priceObject['prices'][Object.keys(priceObject['prices'])[0]],2);
  } 

  var overlaminationPrice = 0;
  var foilPrice = 0;
  var numberingPrice = 0;
  var mattePrice = 0;
  $('#overlaminationPrice, #foilPrice, #numberingPrice, #mattePrice').attr('added','no');
  if(overlamination){
    overlaminationPrice = getDiscountedPrice(overlaminationQty,priceObject,'overlamination', lot_pricing);
    $('#overlaminationPrice').attr('added','yes');
  }
  if(foil_stamping){
    foilPrice = getDiscountedPrice(foilStampingQty,priceObject,'foil', lot_pricing);
    $('#foilPrice').attr('added','yes');
  }
  if(numbering){
    numberingPrice = getDiscountedPrice(numberingQty,priceObject,'numbering', lot_pricing);
    $('#numberingPrice').attr('added','yes');
  }
  if(matte){
    mattePrice = getDiscountedPrice(matteQty,priceObject,'matte', lot_pricing);
    $('#mattePrice').attr('added','yes');
  }
  var qty = getQty(true);
  qty = (isNaN(qty) || qty <= 0)? 1 : qty;
  var finalPrice = 0;
  var unitPrice = 0;
  var inclusivenUnitPrice = 0;
  if(discountedPrice <= 0){
    discountedPrice = basePrice;
  }
  unitPrice = totalQty < minLotQty ? (minLotQty*discountedPrice)/totalQty :  1*discountedPrice;
  inclusivenUnitPrice = unitPrice + overlaminationPrice + foilPrice + numberingPrice + mattePrice;

  initialPrice = (1*initialPrice) + overlaminationPrice + foilPrice + numberingPrice + mattePrice;
  inclusivenUnitPrice = toFixed(inclusivenUnitPrice,2);
  finalPrice = toFixed(qty*inclusivenUnitPrice,2);
  
  if(!isNaN(finalPrice)){
    finalPrice = (finalPrice*100)/100;
  }
  if(!isNaN(inclusivenUnitPrice)){
    inclusivenUnitPrice = (inclusivenUnitPrice*1000)/1000;
    initialPrice = (initialPrice*1000)/1000;
  }

  if (typeof lotSize !== 'undefined') {
    if(lot_pricing && lotSize){
      initialPrice = initialPrice/lotSize;
    }
  }

  var formattedFinalPrice = isNaN(finalPrice)?'':'$'+(Math.round(finalPrice.toFixed(2) * 100 ) / 100).toFixed(2);
  var formattedInclusiveUnitPrice = isNaN(inclusivenUnitPrice)?'':'$'+inclusivenUnitPrice+' /unit';
  var tableSavingPercentage = Math.round(( (initialPrice * qty).toFixed(2) - (inclusivenUnitPrice * qty).toFixed(2))/(initialPrice * qty).toFixed(2) * 100)
  
  $('#productPrice').html(formattedFinalPrice);
  document.querySelector('.custom-quantity-table-row .quantity-table--total').innerText = formattedFinalPrice;
  document.querySelector('.custom-quantity-table-row .custom-quantity-table--unit-ptice').innerText = formattedInclusiveUnitPrice.replace(' /unit','');
  document.querySelector('.custom-quantity-table-row .savings-cell .saving-percentage').innerText = `- ${tableSavingPercentage}%`;
  tableSavingPercentage <= 0 ? document.querySelector('.custom-quantity-table-row .savings-cell').classList.add('saving-hidden') : document.querySelector('.custom-quantity-table-row .savings-cell').classList.remove('saving-hidden')
  $('.unitPrice').html(formattedInclusiveUnitPrice);
  
  $('#priceProperty').val((unitPrice.toFixed(2))); // unit price passed to product property.
  $('#overlaminationPrice').val(overlaminationPrice);
  $('#foilPrice').val(foilPrice);
  $('#numberingPrice').val(numberingPrice);
  $('#mattePrice').val(mattePrice);
  
  if(discountedPrice < basePrice && totalQty > currentQty){
    $('.pro_desc_note_save').hide();
    $('.pro_desc_note_discount').show();
    $('.cart-discount-message').css('display', 'flex');
  }else{
    $('.pro_desc_note_save').show();
    $('.pro_desc_note_discount').hide();
    $('.cart-discount-message').hide();
  }
  
  validateQty(priceObject);
}

function onPriceLoad(){
  var currentQty = getQty(true);
  var selectedVariantId = $selVarEle.val();
  var selectedVariantSku = $selVarEle.find('[value='+selectedVariantId+']').first().data('sku');
  var selectedVariantBarcode = getBarcodeFromSku(selectedVariantSku);
  var priceObject = getPricingObject(selectedVariantBarcode, currentProductPriceJson);
  setQtyOptions(priceObject, $('#quantity-dropdown'), lot_pricing, currentQty);
  const tableQtySelect = document.querySelectorAll('.quantity-table--select');
  tableQtySelect.forEach(select => {
    select.addEventListener('click', (e) => {
      onQtyRadioSelect(e)
    })
  });
}

function onQtyRadioSelect(e) {
    const selectedElement = document.querySelector('.quantity-table--select.selected');
    if (selectedElement) {
      selectedElement.classList.remove('selected');
    }
    e.target.closest('.quantity-table--select').classList.add('selected');
    if( e.target.classList.contains('custom-quantity-table--select') || $(e.target).parents().hasClass('custom-quantity-table--select') ) {
      document.getElementById('quantity-dropdown').value = 'custom';
    } else {
      document.getElementById('quantity-dropdown').value = e.target.closest('[data-value]').getAttribute('data-value');
    }
    
    document.getElementById('custom-quantity-input').value = e.target.closest('[data-value]').getAttribute('data-value');
    document.querySelector('.custom-quantity-table--select').closest('[data-value]').setAttribute('data-value', e.target.closest('[data-value]').getAttribute('data-value'));
    document.getElementById('quantity-dropdown').dispatchEvent(new Event('change'));
}


function selectFirstVariant(){
    $('.main-product-select select').each(function(){
      if(!isset($(this).val())){
      $(this).val($(this).find('option').first().val()).change(); // Select first option of all dropdowns
      }
  });
}

function validateDecimalPlaces(val, numOfPlaces){
  val = String(val);
  if(val.indexOf('.') > -1){
    var splits = val.split('.');
    if(splits[1].length > numOfPlaces){
      return false;
    }
  }
  return true;
}

/******** product page specific ***end***/
window.addEventListener('load', (event) => {
  localStorage.removeItem("hasQtyOptionBeenSelected");
  localStorage.setItem('customQuantity', 0);
  if(isset(page) && page == "product" && price_file_url){
    /* Runs on product page only */

    if($('.variations .top_row .col-select-size:visible').length % 2 != 0){
      $('.variations .top_row .col-select-size:visible:last-child').removeClass('col-sm-6');
    }

    var priceJson = false;
    $.getJSON(price_file_url,function(json){
      currentProductPriceJson = json;
      validatePricingJson(currentProductPriceJson, null, ({ isJsonValid, errorMessage }) => {
        if (!isJsonValid) {
          if(window.location.origin === "https://stomp-stickers.myshopify.com") {
            alert(errorMessage);
          } else {
            console.log(errorMessage);
          }
        }
      });
    }).fail(function(){
      const errorMessage = `JSON ajax failed. Please make sure the JSON file ${price_file_url} exists`;
      if(window.location.origin === "https://stomp-stickers.myshopify.com") {
        alert(errorMessage);
      } else {
        console.error(errorMessage);
      }
    }).always(function(json) {
      onPriceLoad();
      
    });
    $('#quantity').on('change keypress input', function(){
      if (typeof updateCartEditSelectedQuantity === 'function') {
        updateCartEditSelectedQuantity($(this).val());
      }
      setPricing();
    });
    $('#custom-quantity-input').on('change keypress input', function(){
      if (typeof updateCartEditSelectedQuantity === 'function') {
        updateCartEditSelectedQuantity($(this).val());
      }
      if (document.querySelector('.custom-quantity-table-row .custom-quantity-table--select.selected')) {
        document.getElementById('quantity').value = $('#custom-quantity-input')[0].value
        localStorage.setItem('customQuantity', $('#custom-quantity-input')[0].value);
        setPricing()
      } else {
        document.getElementById('quantity-dropdown').value = 'custom';
        document.getElementById('quantity').value = $('#custom-quantity-input')[0].value
        localStorage.setItem('customQuantity', $('#custom-quantity-input')[0].value);
        const selectedElement = document.querySelector('.quantity-table--select.selected');
        if (selectedElement) {
          selectedElement.classList.remove('selected');
        }
        document.getElementById('quantity-dropdown').dispatchEvent(new Event('change'));
        document.querySelector('.custom-quantity-table--select').classList.add('selected');
        setPricing()
      }
    });
    $('.shopify-product-form').submit(function(){
      return validateQty();
    });
    document.querySelector('.shopify-product-form').addEventListener('keydown', function(e) {
      if (e.key == 'Enter') {
          e.preventDefault();
          return false;
      }
  });
    $('.addons').change(function(){
      if($(this).data('var') != ""){
        window[$(this).data('var')] = $(this).prop("checked");
        setPricing();
      }
    })

    setTimeout(function() {
      $selVarEle.change(function(){
        onPriceLoad();
      });
      $('.addons').trigger('change');
    }, 2000);

    var maxSqInches = 0;
    var minSqInches = 999*999;
    $('.main-product-select select').change(function(){
     $(this).parents('.main-product-select').find('.variation-selections').val($(this).val());
    });
    if(hasCustomSize){
      $('.select-size-dummy option, .select-size option').each(function(i,e){
        var val = $(e).html();
        if(val.indexOf('ustom') > -1){
          return;
        }
        var splits = val.split('x');
        splits = splits.map( split => {
          return Number($.trim(split.replace(/"|”/g,'')));
        });

        if(splits.length != 2){
          console.error('at least 1 size is wrongly formatted');
          return;
        }
        var square = splits[0]*splits[1];
        $(e).attr('width',splits[0]);
        $(e).attr('height',splits[1]);
        $(e).attr('square',square);

        if(maxSqInches < square){
          maxSqInches = square;
        }
        if(minSqInches > square){
          minSqInches = square;
        }
      });
    }
    $('.select-size-dummy').on('change',function(){
      var val = $(this).val();
      if(val == 'custom'){
        $('#width, #height').val('').change();
        $(this).parent().siblings('.custom-sizes').show();
        $('.select-size').val($('.select-size option').first().html()).change();
      }else{
        $('.select-size').val(val).change();
        $(this).parent().siblings('.custom-sizes').hide();
      }
    });
    $('.select-size-dummy').change();
    $('#width, #height, .select-size-dummy').on('change keypress input', function(e){
      errors.size = [];
      $parent = $(this).parents('.main-product-select').first();
      checkForErrors($parent.find('#addToCart'));
      if($parent.find('.select-size-dummy').val() == 'custom'){

        var width = Number($parent.find('#width').val());
        var height = Number($parent.find('#height').val());
        var square = width * height;

        if(!custom_die_cut){
          if(width == "" || height == ""){
            $('.price').hide();
            errors.size.push('Please enter your height &amp; width dimensions.');
            checkForErrors($parent.find('#addToCart'));
          }else if(square < minSqInches || square > maxSqInches){
            $('.price').hide();
            errors.size.push('Your custom size exceeds our minimum or maximum values.');
            checkForErrors($parent.find('#addToCart'));
          }else if(!validateDecimalPlaces(width, 2) || !validateDecimalPlaces(height, 2)){
            $('.price').hide();
            errors.size.push('Only 2 decimals are allowed for custom size.');
            checkForErrors($parent.find('#addToCart'));
          }
        }
        

        

        var allApplicationOptions = [];
        var allOptions = [];
        $parent.find('.select-size option').each(function(i,e){
          allOptions.push({w: Number($(e).attr('width')), h: Number($(e).attr('height')), square: Number($(e).attr('width'))*Number($(e).attr('height'))});
          if($(e).attr('square') >= width * height){
            allApplicationOptions.push({w: Number($(e).attr('width')), h: Number($(e).attr('height')), square: Number($(e).attr('width'))*Number($(e).attr('height'))});
          }
        });
        
        var selectThisSize = {w: 999, h: 999, square: 999 * 999};
        allApplicationOptions.sort((a,b) => (a.square > b.square) ? 1 : ((b.square > a.square) ? -1 : 0));
        allOptions.sort((a,b) => (a.square > b.square) ? 1 : ((b.square > a.square) ? -1 : 0));
        
        allApplicationOptions.forEach(function(thisOption){
          if(selectThisSize.square > thisOption.square){
            selectThisSize = thisOption;
          }
        });
        
        var allWidths = allOptions.map(function(opt){ return opt.w });
        var allHeights = allOptions.map(function(opt){ return opt.h });
        var allValues = allWidths.concat(allHeights);

        var minWidth = Math.min.apply(Math, allWidths);
        var maxWidth = Math.max.apply(Math, allWidths);
        var minHeight = Math.min.apply(Math, allHeights);
        var maxHeight = Math.max.apply(Math, allHeights);
        
        var minSquare = minWidth*minHeight;
        var maxSquare = maxWidth*maxHeight;
        
        var minValue = Math.min.apply(Math, allValues);
        var maxValue = Math.max.apply(Math, allValues);
        
        $parent.find('.select-size').val($parent.find('.select-size option[width="'+selectThisSize.w+'"][height="'+selectThisSize.h+'"]').html()).change();
        $parent.find('#custom_size_prop_input').attr('name','properties[Custom Size]').val(width+'" x '+height+'"');
        
        if(width == "" || height == ""){
            $('.price').hide();
            errors.size.push('Please enter your height &amp; width dimensions.');
            checkForErrors($parent.find('#addToCart'));
        }else if($parent.find('.select-size').val() == null || 
           width < minValue || width > maxValue || height < minValue || height > maxValue ||
           square < minSquare || square > maxSquare){
          $('.price').hide();
          errors.size.push('Your custom size exceeds our minimum or maximum values.');
          checkForErrors($parent.find('#addToCart'));
        }

        setPricing();
      }else{
        $parent.find('#custom_size_prop_input').attr('name','').val('');
      }
    });
    if(!custom_die_cut){
      $('.select-size-dummy').change();
    }
    $('form[action*="/cart/add"]').submit(function(e) {
      e.preventDefault();
      if (typeof window.stompApplySavedArtworkOptions === 'function') {
        window.stompApplySavedArtworkOptions();
      }
      var items = [];
      var productData = objectifyForm($(this));
      items.push(productData);
      if($('#overlaminationPrice').val() != "" && $('#overlaminationPrice').attr('added') == 'yes'){
        items.push({
          id          : overlamVariantId,
          quantity    : productData.quantity,
          properties  : {
            "Item Price"  : $('#overlaminationPrice').val(),
          }
        });
      }
      if($('#foilPrice').val() != "" && $('#foilPrice').attr('added') == 'yes'){
        items.push({
          id          : foilVariantId,
          quantity    : productData.quantity,
          properties  : {
            "Item Price"  : $('#foilPrice').val(),
          }
        });
      }
      if($('#numberingPrice').val() != "" && $('#numberingPrice').attr('added') == 'yes'){
        items.push({
          id          : numberingVariantId,
          quantity    : productData.quantity,
          properties  : {
            "Item Price"  : $('#numberingPrice').val(),
          }
        });
      }
      if($('#mattePrice').val() != "" && $('#mattePrice').attr('added') == 'yes'){
        items.push({
          id          : matteVariantId,
          quantity    : productData.quantity,
          properties  : {
            "Item Price"  : $('#mattePrice').val(),
          }
        });
      }
      items.forEach(item=>{
        if(isset(item.properties['Custom Size'])){
          delete item.properties['Size'];
        }
      })
      addToCart(items);
    });
  }
  if(isset(page) && page == "product"){
    setTimeout(function(){ selectFirstVariant() }, 1000);
    selectFirstVariant()
  }

  const tableShowMore = document.querySelector('.show-more-dropdown');
  const tableQty = document.getElementById('quantity-table');
  const tableHiddenRows = document.querySelectorAll('.table-row-hide');

  // if (tableHiddenRows.length == 0) {
  //   console.log(tableHiddenRows.length, tableHiddenRows)
  //   tableShowMore.style.display = 'none'
  // }
  
  tableShowMore.addEventListener('click', function toggleShowMore(e) {
    tableQty.classList.toggle('show-more__active')
    if(tableQty.classList.contains('show-more__active')) {
      document.querySelector('.show-more-dropdown span').innerText = 'Show less quantities'
      document.querySelector('.show-more-dropdown span.caret').style.transform = 'rotate(180deg)';
    } else {
      document.querySelector('.show-more-dropdown span').innerText = 'Show more quantities'
      document.querySelector('.show-more-dropdown span.caret').style.transform = 'rotate(360deg)';
    }
  })

});

function toFixed( number, decimals ) {
  const x = Math.pow(10, Number(decimals) + 2);
  return (Number(number) + (1 / x)).toFixed(decimals)
}
